
import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";
import { Membership } from "../../../utils/types";

export const useMembersData = () => {
  const [members, setMembers] = useState<Membership[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    fetchMembers();
  }, []);

  const fetchMembers = async () => {
    try {
      setIsLoading(true);
      setError(null);
      
      const { data, error } = await supabase
        .from('memberships')
        .select('id, first_name, last_name, email, phone, amount, payment_status, membership_type, created_at, additional_donation')
        .order('created_at', { ascending: false });
      
      if (error) {
        throw error;
      }
      
      setMembers(data || []);
    } catch (err) {
      console.error("Erreur lors de la récupération des membres:", err);
      setError("Impossible de récupérer les données des membres.");
    } finally {
      setIsLoading(false);
    }
  };

  return { members, isLoading, error, fetchMembers };
};
